import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/src/containers/components/htmlContent/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/containers/components/layouts/Banner/BannerSkeleton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/containers/components/layouts/Banner/components/MobileBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/containers/components/layouts/DualLayout.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/containers/website/hotel/results/hotelResultsBody/mainContent/components/HotelList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/common/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/common/breadCrumb/BreadCrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/common/breadCrumb/BreadCrumbSkeleton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/common/CollapsibleContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/filters/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/components/searchTab/components/tabs/hotel/HotelTab.tsx");
